/**
 * Tab Horas — lançamentos de hora agregados por fase.
 * Simples por enquanto — refinar com filtros/edição inline depois.
 */

import React, { useEffect, useMemo, useState } from 'react';
import { fasesAPI } from '../../../services/inovacaoAPI';

export default function Lancamentos({ projeto, fases }) {
  const [porFase, setPorFase] = useState({});

  useEffect(() => {
    Promise.all(fases.map((f) =>
      fasesAPI.listarLancamentos(f.id).then((l) => [f.id, l]).catch(() => [f.id, []])
    )).then((pairs) => setPorFase(Object.fromEntries(pairs)));
  }, [fases]);

  const totalHoras = useMemo(() => {
    return Object.values(porFase).flat().reduce((s, l) => s + parseFloat(l.horas || 0), 0);
  }, [porFase]);

  const porUsuario = useMemo(() => {
    const m = {};
    Object.values(porFase).flat().forEach((l) => {
      const nome = l.usuario?.nome || 'Desconhecido';
      m[nome] = (m[nome] || 0) + parseFloat(l.horas || 0);
    });
    return Object.entries(m).sort((a, b) => b[1] - a[1]);
  }, [porFase]);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 16 }}>
      <div style={cardStyle}>
        <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>
          Lançamentos ({totalHoras.toFixed(1)}h totais)
        </h3>
        {fases.map((f) => {
          const l = porFase[f.id] || [];
          if (l.length === 0) return null;
          return (
            <div key={f.id} style={{ marginBottom: 20, borderLeft: '3px solid var(--brand, #20a490)', paddingLeft: 12 }}>
              <h4 style={{ margin: '0 0 8px', fontSize: '0.95rem', color: '#2c3e50' }}>
                {f.nome} <span style={{ color: '#7f8c8d', fontWeight: 400, fontSize: '0.8rem' }}>
                  ({l.reduce((s, x) => s + parseFloat(x.horas), 0)}h)
                </span>
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {l.map((x) => (
                  <li key={x.id} style={{ padding: '4px 0', fontSize: '0.85rem' }}>
                    <b>{x.horas}h</b>
                    <span style={{ color: '#7f8c8d' }}> · {x.data} · {x.usuario?.nome}</span>
                    {x.descricao && <span style={{ color: '#555' }}> · {x.descricao}</span>}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
        {totalHoras === 0 && <p style={{ color: '#bdc3c7' }}>Nenhum lançamento ainda.</p>}
      </div>

      <div style={cardStyle}>
        <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>Por pessoa</h3>
        {porUsuario.map(([nome, h]) => {
          const pct = totalHoras > 0 ? (h / totalHoras) * 100 : 0;
          return (
            <div key={nome} style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', marginBottom: 3 }}>
                <span>{nome}</span>
                <b>{h.toFixed(1)}h</b>
              </div>
              <div style={{ height: 6, background: '#ecf0f1', borderRadius: 3 }}>
                <div style={{ height: '100%', width: `${pct}%`, background: 'var(--brand, #20a490)', borderRadius: 3 }} />
              </div>
            </div>
          );
        })}
        {porUsuario.length === 0 && <p style={{ color: '#bdc3c7' }}>Sem dados.</p>}
      </div>
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 12, padding: 20,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
